import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Snackbar, Alert } from '@mui/material';

SnackBarAlert.propTypes = {
  open: PropTypes.bool,
  severity: PropTypes.string,
  title: PropTypes.string,
  handleClose: PropTypes.func,
  wrapContent: PropTypes.bool,
  autoHideDuration: PropTypes.number
};

export default function SnackBarAlert({
  open,
  severity,
  title,
  handleClose,
  wrapContent,
  autoHideDuration
}) {
  const [state, setState] = useState({
    vertical: 'center',
    horizontal: 'center'
  });
  const { vertical, horizontal } = state;

  return (
    <Snackbar
      sx={{ zIndex: 1000000 }}
      open={open}
      autoHideDuration={autoHideDuration ?? 4000}
      onClose={handleClose}
      anchorOrigin={{ vertical, horizontal }}
      data-testid="snackbar"
    >
      <Alert
        onClose={handleClose}
        severity={severity || 'info'}
        variant="filled"
        sx={{
          width: '100%',
          fontFamily: 'Montserrat',
          fontSize: '14px',
          ...(wrapContent && {
            maxWidth: { xs: 'min(100vw - 32px, 480px)', sm: 520 },
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word'
          })
        }}
      >
        {title}
      </Alert>
    </Snackbar>
  );
}
